/* tslint:disable */
/* eslint-disable */
/**
 * Agent service API
 * Service for credentials management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CredDto
 */
export interface CredDto {
    /**
     * Self-Addressing Identifier. Primary credential id
     * @type {string}
     * @memberof CredDto
     */
    said?: string;
    /**
     * SAID of the credential type - it is called Credential Schema
     * @type {string}
     * @memberof CredDto
     */
    schemaSaid?: string;
    /**
     * AID of issuer - who created that credential
     * @type {string}
     * @memberof CredDto
     */
    issuerAid?: string;
    /**
     * AID of credential holder
     * @type {string}
     * @memberof CredDto
     */
    holderAid?: string;
    /**
     * Any additional credential details. Usually it is credentials cesr
     * @type {string}
     * @memberof CredDto
     */
    details?: string;
}

/**
 * Check if a given object implements the CredDto interface.
 */
export function instanceOfCredDto(value: object): boolean {
    return true;
}

export function CredDtoFromJSON(json: any): CredDto {
    return CredDtoFromJSONTyped(json, false);
}

export function CredDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CredDto {
    if (json == null) {
        return json;
    }
    return {
        
        'said': json['said'] == null ? undefined : json['said'],
        'schemaSaid': json['schemaSaid'] == null ? undefined : json['schemaSaid'],
        'issuerAid': json['issuerAid'] == null ? undefined : json['issuerAid'],
        'holderAid': json['holderAid'] == null ? undefined : json['holderAid'],
        'details': json['details'] == null ? undefined : json['details'],
    };
}

export function CredDtoToJSON(value?: CredDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'said': value['said'],
        'schemaSaid': value['schemaSaid'],
        'issuerAid': value['issuerAid'],
        'holderAid': value['holderAid'],
        'details': value['details'],
    };
}

